angular.module 'zc.master.users'

.controller 'MasterUsersCtrl', ($q, $scope, $translate, Devise, MasterUser, Page) ->
  Page.setBodyClass ''
  $translate('masterUsers.list.usersList').then (translation) ->
    Page.setTitle translation

  $scope.filteredUsers = []
  $scope.openProject = false

  # filters
  $scope.filters =
    per_page: 100
    page: 1
    total_count: 0
    sort_prop: 'id'
    sort_direction: 'desc'
    search_term: ''
    visible_group: 'settings'

  $scope.setVisibleGroup = (visibleGroup) ->
    $scope.filters.visible_group = visibleGroup

  $scope.setSortProp = (key) ->
    if $scope.filters.sort_prop == key
      if $scope.filters.sort_direction == 'desc'
        $scope.filters.sort_direction = 'asc'
      else
        $scope.filters.sort_direction = 'desc'
    else
      $scope.filters.sort_prop = key
      $scope.filters.sort_direction = 'desc'
    $scope.filterUsers()

  $scope.filterUsers = () ->
    omit_filter_attrs = [
      'visible_group',
      'total_count'
    ]
    unless $scope.filters.search_term
      omit_filter_attrs.push 'search_term'
    MasterUser.all _.omit $scope.filters, omit_filter_attrs
    .then (res) ->
      $scope.filteredUsers = res.users
      $scope.filters.total_count = res.total_count

  $scope.updateData = () ->
    return unless $scope.filters.search_term
    $scope.filters.page = 1
    $scope.filterUsers()

  $scope.becomeUser = (id) ->
    Devise.become({id: id})

  $scope.resetSearchTerm = () ->
    $scope.filters.search_term = ""
    $scope.filterUsers()

  $scope.filterUsers()



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.users/list.controller.js.coffee